export const CHANNEL_LABELS = {
  siteminder: "SiteMinder",
  bookingcom: "Booking.com",
  expedia: "Expedia",
  agoda: "Agoda",
  traveloka: "Traveloka",
  tripcom: "Trip.com",
};

export const initialMappingForm = {
  channel: "siteminder",
  room: undefined,
  ratePlan: undefined,
  roomTypeCode: "",
  ratePlanCode: "",
  roomTypeName: "",
  ratePlanName: "",
  includedAdultOccupancy: 2,
  rateSetupType: "Manual",
};
